module.exports = __webpack_public_path__ + "img/25.5581a706.png";